<mat-card class="p-0">
  <form *ngIf="itemForm" [formGroup]="itemForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
      <!-- Botões de Ação Superior -->
      <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px">
        <button mat-raised-button color="accent" (click)="close()">
          <mat-icon>arrow_back</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
        </button>
        <button mat-raised-button color="primary" [matTooltip]="'Salvar Produto'" (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Mais Opções">
          <mat-icon>more_vert</mat-icon>
          Mais Opções
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openAnexoUploadListPopUp(produto); $event.preventDefault();">
            <mat-icon>attachment</mat-icon> Anexos
          </button>
          <button mat-menu-item (click)="openCodbarPopUp(produto); $event.preventDefault();">
            <mat-icon>qr_code</mat-icon> Código de Barras
          </button>
          <button mat-menu-item (click)="openMovtoPopUp(produto); $event.preventDefault();">
            <mat-icon>storage</mat-icon> Movimentações
          </button>
          <button mat-menu-item (click)="openTribPopUp(produto); $event.preventDefault();">
            <mat-icon>percentage</mat-icon> Tributação
          </button>
          <button mat-menu-item (click)="openPrecoPopUp(produto); $event.preventDefault();">
            <mat-icon>monetization_on</mat-icon> Preços
          </button>
          <button mat-menu-item (click)="openImagesPopUp(produto); $event.preventDefault();">
            <mat-icon>image</mat-icon> Imagens/Foto
          </button>
        </mat-menu>
      </div>

      <!-- Conteúdo Principal -->
      <div fxFlex="100">
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="tab-content">
          <!-- Dados Básicos -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>Cadastro de Produto - Dados Básicos</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Descrição</mat-label>
                    <input [imask]="maskUpper" matInput name="descricao" type="text" [formControl]="itemForm?.controls['descricao']" />
                    <mat-error *ngIf="itemForm?.controls['descricao']?.hasError('required') && itemForm?.controls['descricao']?.touched">
                      Descrição é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Grupo/Categoria</mat-label>
                    <mat-select [formControl]="itemForm?.controls['fatGrupoprodutos']">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchGrupo']" placeholderLabel="Pesquisar Grupo/Categoria..."
                          noEntriesFoundLabel="Grupo/Categoria não encontrado" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let grupo of grupos" [value]="grupo">
                        {{ grupo.id.toString().padStart(3, '0') }} - {{ grupo.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Marca</mat-label>
                    <mat-select [formControl]="itemForm?.controls['fatMarca']">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchMarca']" placeholderLabel="Pesquisar Marca..."
                          noEntriesFoundLabel="Marca não encontrado" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let marca of fatMarcas" [value]="marca">
                        {{ marca.id.toString().padStart(3, '0') }} - {{ marca.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Tipo</mat-label>
                    <mat-select [formControl]="itemForm?.controls['tipo']">
                      <mat-option *ngFor="let tipo of enums?.tipoProduto" [value]="tipo.descricao">
                        {{ tipo.descricao }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Referência</mat-label>
                    <input [imask]="maskUpper" matInput name="referencia" type="text" [formControl]="itemForm?.controls['referencia']" />
                    <mat-error *ngIf="itemForm?.controls['referencia']?.hasError('required') && itemForm?.controls['referencia']?.touched">
                      Referência é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Classificação Gerencial [Centro de Custo]</mat-label>
                    <mat-select [formControl]="itemForm?.controls['classificacaoGerencial']" (selectionChange)="onSelectionChangeClassificacaoGerencial($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchClassificacaoGerencial']" placeholderLabel="Pesquisar Classificação Gerencial..."
                          noEntriesFoundLabel="Classificação Gerencial [Centro de Custo] não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let classificacao of classificacoesGerenciais$ | async" [value]="classificacao">
                        {{ classificacao.codigo.toString().padStart(5, '0') }} - {{ classificacao.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Unidades -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>Unidades</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                <div fxFlex="20" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 1</mat-label>
                    <mat-select [formControl]="itemForm?.controls['cadUnidade1']" (selectionChange)="onSelectionChangeCadUnidade1($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchUnidade1']" placeholderLabel="Pesquisar Unidade 1..."
                          noEntriesFoundLabel="Unidade 1 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade1 of unidades$ | async" [value]="cadUnidade1">
                        {{ cadUnidade1.id }} - {{ cadUnidade1.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="itemForm?.controls['cadUnidade1']?.hasError('required') && itemForm?.controls['cadUnidade1']?.touched">
                      Unidade 1 é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 2</mat-label>
                    <mat-select [formControl]="itemForm?.controls['cadUnidade2']" (selectionChange)="onSelectionChangeCadUnidade2($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchUnidade2']" placeholderLabel="Pesquisar Unidade 2..."
                          noEntriesFoundLabel="Unidade 2 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ cadUnidade.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 3</mat-label>
                    <mat-select [formControl]="itemForm?.controls['cadUnidade3']" (selectionChange)="onSelectionChangeCadUnidade3($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchUnidade3']" placeholderLabel="Pesquisar Unidade 3..."
                          noEntriesFoundLabel="Unidade 3 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ cadUnidade.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 4</mat-label>
                    <mat-select [formControl]="itemForm?.controls['cadUnidade4']" (selectionChange)="onSelectionChangeCadUnidade4($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchUnidade4']" placeholderLabel="Pesquisar Unidade 4..."
                          noEntriesFoundLabel="Unidade 4 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ cadUnidade.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade Padrão</mat-label>
                    <mat-select [formControl]="itemForm?.controls['cadUnidadePadraoVenda']" (selectionChange)="onSelectionChangeCadUnidadePadraoVenda($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchUnidadePadrao']" placeholderLabel="Pesquisar Unidade Padrão..."
                          noEntriesFoundLabel="Unidade Padrão não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ cadUnidade.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 1</mat-label>
                    <input matInput name="fatorunidade1" type="text" [formControl]="itemForm?.controls['fatorunidade1']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 2</mat-label>
                    <input matInput name="fatorunidade2" type="text" [formControl]="itemForm?.controls['fatorunidade2']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 3</mat-label>
                    <input matInput name="fatorunidade3" type="text" [formControl]="itemForm?.controls['fatorunidade3']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Dados Específicos (Automação) -->
          <mat-card fxFlex="100" class="section-card" *ngIf="layoutConf.isEmpresaAutomacao">
            <mat-card-title>Dados Específicos (Automação)</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Tipo Produto na Composição</mat-label>
                    <mat-select [formControl]="itemForm?.controls['tipoProdutoAutom']">
                      <mat-option *ngFor="let tipoP of enums?.tipoProdutoAutom" [value]="tipoP.name">
                        {{ tipoP.descricao }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Bomba</mat-label>
                    <mat-select [formControl]="itemForm?.controls['automBomba']">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="itemForm?.controls['searchAutomBomba']" placeholderLabel="Pesquisar Bomba..."
                          noEntriesFoundLabel="Bomba não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngIf="produto?.automBomba" [value]="produto?.automBomba">
                        {{ produto?.automBomba?.codigo.toString().padStart(3, '0') }} - {{ produto?.automBomba?.descricao.trim() }}
                      </mat-option>
                      <mat-option *ngFor="let bba of automBombas" [value]="bba">
                        {{ bba?.codigo.toString().padStart(3, '0') }} - {{ bba?.descricao.trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Dimensões e Outros -->
          <mat-card fxFlex="100" class="section-card" *ngIf="!layoutConf.isEmpresaAutomacao">
            <mat-card-title>Dimensões e Outros</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Leiaute da Etiqueta</mat-label>
                    <mat-select [formControl]="itemForm?.controls['layoutEtiquetaBalanca']">
                      <mat-option *ngFor="let leiaute of enums?.layoutEtiquetaBalanca" [value]="leiaute.name">
                        {{ leiaute.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Peso Bruto (Kg)</mat-label>
                    <input matInput name="pesobruto" type="text" [formControl]="itemForm?.controls['pesobruto']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Peso Líquido (Kg)</mat-label>
                    <input matInput name="pesoliquido" type="text" [formControl]="itemForm?.controls['pesoliquido']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Localização</mat-label>
                    <input [imask]="maskUpper" matInput name="localizacao" type="text" [formControl]="itemForm?.controls['localizacao']" />
                    <mat-error *ngIf="itemForm?.controls['localizacao']?.hasError('required') && itemForm?.controls['localizacao']?.touched">
                      Localização é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Largura (Cm)</mat-label>
                    <input matInput name="largura" type="text" [formControl]="itemForm?.controls['largura']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Altura (Cm)</mat-label>
                    <input matInput name="altura" type="text" [formControl]="itemForm?.controls['altura']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Profundidade (Cm)</mat-label>
                    <input matInput name="profundidade" type="text" [formControl]="itemForm?.controls['profundidade']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Prazo de Entrega (Dias)</mat-label>
                    <input matInput name="prazoEntrega" type="text" [formControl]="itemForm?.controls['prazoEntrega']" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Complemento e Dados Adicionais -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>Complemento e Dados Adicionais</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                <div fxFlex="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Complemento</mat-label>
                    <input [imask]="maskUpper" matInput name="complemento" type="text" [formControl]="itemForm?.controls['complemento']" />
                    <mat-error *ngIf="itemForm?.controls['complemento']?.hasError('required') && itemForm?.controls['complemento']?.touched">
                      Complemento é obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="100">
                  <quill-editor name="dadosadicionais" [formControl]="itemForm?.controls['dadosadicionais']" placeholder="Dados adicionais"
                    theme="snow" [styles]="{ height: '100px' }"></quill-editor>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Botões Inferiores -->
    <mat-card-actions>
      <div fxFlex="100" class="action-buttons">
        <button mat-raised-button color="primary" [matTooltip]="'Salvar Produto'" (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
      </div>
    </mat-card-actions>
  </form>
</mat-card>